import axios from "axios";
import { ENDPOINTS } from "../../apis/endpoints";
import { apiSlice } from "../../app/api/apiSlice";
import { setPingsAttachmentUploadProgress } from "./announcementSlice";

export const announcementApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAnnouncements: builder.query({
      query: () => `${ENDPOINTS.ANNOUNCEMENT.BASE}`,
      providesTags: result =>
        result
          ? [{ type: "Announcement", id: "LIST" }, ...result.map(({ _id }) => ({ type: "Announcement", id: _id }))]
          : [{ type: "Announcement", id: "LIST" }],
    }),
    addAnnouncement: builder.mutation({
      queryFn: async (formData, api) => {
        try {
          const token = api.getState().auth.token;
          const result = await axios.post(`${process.env.REACT_APP_BASE_URL}${ENDPOINTS.ANNOUNCEMENT.BASE}`, formData, {
            //...other options like headers here
            headers: {
              Authorization: `Bearer ${token}`,
            },
            onUploadProgress: upload => {
              //Set the progress value to show the progress bar
              let uploadloadProgress = Math.round((100 * upload.loaded) / upload.total);
              // api.dispatch(setUploadProgress(uploadloadProgress ));
              console.log(uploadloadProgress);
              api.dispatch(setPingsAttachmentUploadProgress({ progress: uploadloadProgress, uploadStarted: true }));
            },
          });
          return { data: result.data };
        } catch (axiosError) {
          let err = axiosError;
          return {
            error: {
              status: err.response?.status,
              data: err.response?.data || err.message,
            },
          };
        }
      },
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        console.log("upload started");
        dispatch(setPingsAttachmentUploadProgress({ progress: 0, uploadStarted: true }));

        try {
          const { data } = await queryFulfilled;
          dispatch(setPingsAttachmentUploadProgress({ progress: null, uploadStarted: false }));
        } catch (err) {
          dispatch(setPingsAttachmentUploadProgress({ progress: null, uploadStarted: false }));
        } finally {
          console.log("upload completed");
        }
      },
      invalidatesTags: [{ type: "Announcement", id: "LIST" }],
    }),
    editAnnouncement: builder.mutation({
      query: ({ id, data }) => ({
        url: `${ENDPOINTS.ANNOUNCEMENT.BASE}${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Announcement", id }],
    }),
    deleteAnnouncement: builder.mutation({
      query: id => ({
        url: `${ENDPOINTS.ANNOUNCEMENT.BASE}${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Announcement", id }],
    }),
    deleteAllAnnouncements: builder.mutation({
      query: () => ({
        url: `${ENDPOINTS.ANNOUNCEMENT.DELETE_ALL}`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Announcement", id }],
    }),
    pinAnnouncement: builder.mutation({
      query: id => ({
        url: `${ENDPOINTS.ANNOUNCEMENT.PIN}${id}`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Announcement", id }],
    }),
    unpinAnnouncement: builder.mutation({
      query: id => ({
        url: `${ENDPOINTS.ANNOUNCEMENT.UNPIN}${id}`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Announcement", id }],
    }),
    getLinkPreview: builder.query({
      query: url => `${ENDPOINTS.UTILS.LINK_PREVIEW}?url=${encodeURIComponent(url)}`,
    }),
  }),
});

export const {
  useGetAnnouncementsQuery,
  useAddAnnouncementMutation,
  useEditAnnouncementMutation,
  useDeleteAnnouncementMutation,
  useDeleteAllAnnouncementsMutation,
  usePinAnnouncementMutation,
  useUnpinAnnouncementMutation,
  useGetLinkPreviewQuery,
} = announcementApiSlice;
